import http from "../../http-common";

const get = (data) => http.post("/AccessHistory/FilterAcessHistory", data);

const create = (data) => http.post("/AccessHistory/ValidateAndRegister", data);

export default { get, create };
